<template>

  <table class="table">
    <thead>
    <tr>
      <th>Linha</th>
      <th v-for="(field, index) in columns" :key="index" :title="field.title">
        {{ field.name }}
      </th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, indexRow) in rows" :key="indexRow">
      <td v-if="row.line" :title="`Linha salva (${row.line})`">{{ row.line }}</td>
      <td v-else title="Linha não salva">X</td>
      <td v-for="(field, indexColumn) in row" :key="indexColumn">

        <input v-if="['text', 'number'].includes(getColumn(indexColumn).type)" class="form-control"
               :type="getColumn(indexColumn).type" v-model="field.v">

        <select v-else-if="getColumn(indexColumn).type === 'select'" v-model="field.v" class="form-control">
          <option :value="option[1]" v-for="option in getColumn(indexColumn).options" :key="option[0]">
            {{ option[0] }}
          </option>
        </select>

      </td>
      <td>
        <button @click="move(indexRow, indexRow - 1)" class="btn btn-outline mr-1"
                :disabled="indexRow === 0">para cima</button>
        <button @click="move(indexRow, indexRow + 1)" class="btn btn-outline mr-1"
                :disabled="indexRow + 1 === rows.length">para baixo</button>

        <button @click="$emit('cloneRow', indexRow)" class="btn btn-outline mr-1">Clonar</button>
        <button @click="$emit('removeRow', indexRow)" class="btn btn-outline">{{ 'btn.delete' | t }}</button>
      </td>
    </tr>
    </tbody>
  </table>

</template>

<script>
  export default {
    methods: {
      getColumn(indexColumn) {
        return this.columns[indexColumn]
      },
      move(to, from) {
        this.$emit('move', { from, to })
      },
    },
    name: 'EditTable',
    props: {
      columns: { required: true, type: Array },
      rows: { required: true, type: Array }
    }
  }
</script>

<style scoped>

</style>